import { Select } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  
`;

export const SelectControl = styled(Select)`
  @media (min-width: 600px) {
    width: 350px;
  }
  width: 100%;
`;

export const TranspIcon = styled.span`
  position: absolute;
`;

export const ModalTransp = styled.div`
  margin: 4% 0% 0% 0%;
  width: 95%;
`;
